<div class="flex" gloZoomOnScroll>
    <div class="flex flex-col pt-[198px] pb-[166px] pl-[112px] pr-8">
        <div class="">
            <h1 class="text-5xl pb-6 text-gray-900">Find & Book Your Perfect Salon in Seconds</h1>
            <p class="text-lg pb-12 text-gray-600">Powerful, self-serve product and growth analytics to help you convert, engage, and retain more.</p>
            <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Discover Now</button>
        </div>
    </div>
    <div class="overflow-hidden">
        <img [src]="assetUrl + 'img/whyus1.png'" alt="Why Us">
    </div>
</div>

<div class="flex flex-col px-[112px] pt-10 pb-16">
    <span class="text-md font-semibold text-purple pb-3">Features</span>
    <h2 class="text-3xl text-gray-900 pb-5">Why Customers Love Us</h2>
    <p class="text-gray-600">
        Spend smarter, lower your bills, get cashback on everything you buy, and unlock credit to grow your business.
    </p>
</div>
    
<div class="flex px-20 pb-10 justify-between">
    <div class="flex flex-col pl-8 py-16 pr-16">
        <div class="flex pb-12 items-start">
            <img [src]="assetUrl + 'icons/comment.svg'" class="w-12 pr-3">
            <div class="flex flex-col">
                <h4 class="text-xl font-semibold text-gray-900 pt-1 pb-2">Instant Booking</h4>
                <p class="text-gray-600">No more calling—book anytime, anywhere.</p>
            </div>
        </div>
        <div class="flex pb-12 items-start">
            <img [src]="assetUrl + 'icons/dollar.svg'" class="w-12 pr-3">
            <div class="flex flex-col">
                <h4 class="text-xl font-semibold text-gray-900 pt-1 pb-2">Easy expense policies</h4>
                <p class="text-gray-600">Unlock discounts and special offers at partner salons.</p>
            </div>
        </div>
        <div class="flex items-start">
            <img [src]="assetUrl + 'icons/review.svg'" class="w-12 pr-3">
            <div class="flex flex-col">
                <h4 class="text-xl font-semibold text-gray-900 pt-1 pb-2">Verified Reviews</h4>
                <p class="text-gray-600">Honest feedback from real customers for trusted recommendations.</p>
            </div>
        </div>
    </div>
    <div class="pr-8">
        <img [src]="assetUrl + 'img/whyus2.png'" alt="why us">
    </div>
</div>

<div class="flex justify-between px-[112px] pt-10 pb-16 items-center">
    <div class="flex-col">
        <span class="text-md font-semibold text-purple pb-3">Why gloget?</span>
        <h2 class="text-3xl text-gray-900 pb-5 pt-2">How It Works</h2>
        <p class="text-gray-600">
            Get seamless booking, real-time updates
        </p>
    </div>
    <div>
        <button class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white">Discover Now</button>
    </div>
</div>

<div class="flex px-[112px] pb-10">
    <div class="flex flex-col p-6 bg-gray-50 mr-6">
        <div>
            <img class="pb-10" [src]="assetUrl + 'icons/n1.svg'" alt="number1">
        </div>
        <div>
            <h3 class="text-xl font-semibold pb-2">Search Nearby Salons</h3>
            <p class="text-gray-600">Explore top-rated salons based on location, services, and reviews.</p>
        </div>
    </div>
    <div class="flex flex-col p-6 bg-gray-50 mr-6">
        <div>
            <img class="pb-10" [src]="assetUrl + 'icons/n2.svg'" alt="number1">
        </div>
        <div>
            <h3 class="text-xl font-semibold pb-2">Search Nearby Salons</h3>
            <p class="text-gray-600">Explore top-rated salons based on location, services, and reviews.</p>
        </div>
    </div>
    <div class="flex flex-col p-6 bg-gray-50">
        <div>
            <img class="pb-10" [src]="assetUrl + 'icons/n3.svg'" alt="number1">
        </div>
        <div>
            <h3 class="text-xl font-semibold pb-2">Search Nearby Salons</h3>
            <p class="text-gray-600">Explore top-rated salons based on location, services, and reviews.</p>
        </div>
    </div>
</div>

<landing-start-booking></landing-start-booking>
